import { IBARAKI_REGION_ROUTE } from '@/app/ibaraki-region/constants/region';
import { useEventCardList as useEventCardListBase } from '@/components/EventCardList/hooks';
import { convertToUrlParams } from '@/functions/convertSearchParams';
import { relativePath } from '@/functions/redirectToRelativePath';

export const useEventCardList = (
  searchParams: SearchParams,
  cityDomain: string,
  customerSetting: CustomerSetting
) => {
  const { searchQueryText, ref } = useEventCardListBase(
    searchParams,
    customerSetting
  );

  const createLink = (page: number | null) => {
    const params = convertToUrlParams({
      ...searchParams,
      page: page?.toString() ?? undefined
    });
    return relativePath(
      `/${cityDomain}/list/${params ? '?' : ''}${params}#events`,
      IBARAKI_REGION_ROUTE
    );
  };

  return { searchQueryText, ref, createLink };
};
